import { getContrastRatio } from '@mui/system/colorManipulator';
import { color } from '@/lib/theme/tokens';

export default function contrast(hex) {
  return getContrastRatio(hex, color.text.dark) >= 3
    ? color.text.dark
    : color.text.light;
}
